var AdonisjsOriginalIcon = require("./adonisjs/original"),
    AdonisjsOriginalWordmarkIcon = require("./adonisjs/original-wordmark"),
    AftereffectsOriginalIcon = require("./aftereffects/original"),
    AftereffectsPlainIcon = require("./aftereffects/plain"),
    AmazonwebservicesOriginalIcon = require("./amazonwebservices/original"),
    AmazonwebservicesOriginalWordmarkIcon = require("./amazonwebservices/original-wordmark"),
    AmazonwebservicesPlainWordmarkIcon = require("./amazonwebservices/plain-wordmark"),
    AndroidOriginalIcon = require("./android/original"),
    AndroidOriginalWordmarkIcon = require("./android/original-wordmark"),
    AndroidPlainIcon = require("./android/plain"),
    AndroidPlainWordmarkIcon = require("./android/plain-wordmark"),
    Aarch64OriginalIcon = require("./aarch64/original"),
    Aarch64PlainIcon = require("./aarch64/plain"),
    AngularjsOriginalIcon = require("./angularjs/original"),
    AngularjsOriginalWordmarkIcon = require("./angularjs/original-wordmark"),
    AngularjsPlainIcon = require("./angularjs/plain"),
    AngularjsPlainWordmarkIcon = require("./angularjs/plain-wordmark"),
    ApachePlainIcon = require("./apache/plain"),
    ApachePlainWordmarkIcon = require("./apache/plain-wordmark"),
    ApacheLineIcon = require("./apache/line"),
    ApacheLineWordmarkIcon = require("./apache/line-wordmark"),
    ApachekafkaOriginalIcon = require("./apachekafka/original"),
    ApachekafkaOriginalWordmarkIcon = require("./apachekafka/original-wordmark"),
    AppceleratorOriginalIcon = require("./appcelerator/original"),
    AppceleratorOriginalWordmarkIcon = require("./appcelerator/original-wordmark"),
    AppceleratorPlainWordmarkIcon = require("./appcelerator/plain-wordmark"),
    AppleOriginalIcon = require("./apple/original"),
    AppwriteOriginalIcon = require("./appwrite/original"),
    AppwriteOriginalWordmarkIcon = require("./appwrite/original-wordmark"),
    AppwritePlainIcon = require("./appwrite/plain"),
    AppwritePlainWordmarkIcon = require("./appwrite/plain-wordmark"),
    ArduinoOriginalIcon = require("./arduino/original"),
    ArduinoOriginalWordmarkIcon = require("./arduino/original-wordmark"),
    ArduinoPlainIcon = require("./arduino/plain"),
    ArduinoPlainWordmarkIcon = require("./arduino/plain-wordmark"),
    AtomOriginalIcon = require("./atom/original"),
    AtomOriginalWordmarkIcon = require("./atom/original-wordmark"),
    AzureOriginalIcon = require("./azure/original"),
    AzureOriginalWordmarkIcon = require("./azure/original-wordmark"),
    AzurePlainIcon = require("./azure/plain"),
    AzurePlainWordmarkIcon = require("./azure/plain-wordmark"),
    BabelPlainIcon = require("./babel/plain"),
    BackbonejsOriginalIcon = require("./backbonejs/original"),
    BackbonejsOriginalWordmarkIcon = require("./backbonejs/original-wordmark"),
    BackbonejsPlainIcon = require("./backbonejs/plain"),
    BackbonejsPlainWordmarkIcon = require("./backbonejs/plain-wordmark"),
    BashOriginalIcon = require("./bash/original"),
    BashPlainIcon = require("./bash/plain"),
    BehanceOriginalIcon = require("./behance/original"),
    BehanceOriginalWordmarkIcon = require("./behance/original-wordmark"),
    BehancePlainIcon = require("./behance/plain"),
    BehancePlainWordmarkIcon = require("./behance/plain-wordmark"),
    BitbucketOriginalIcon = require("./bitbucket/original"),
    BitbucketOriginalWordmarkIcon = require("./bitbucket/original-wordmark"),
    BootstrapPlainIcon = require("./bootstrap/plain"),
    BootstrapPlainWordmarkIcon = require("./bootstrap/plain-wordmark"),
    BulmaPlainIcon = require("./bulma/plain"),
    BowerOriginalIcon = require("./bower/original"),
    BowerOriginalWordmarkIcon = require("./bower/original-wordmark"),
    BowerPlainIcon = require("./bower/plain"),
    BowerPlainWordmarkIcon = require("./bower/plain-wordmark"),
    BowerLineIcon = require("./bower/line"),
    BowerLineWordmarkIcon = require("./bower/line-wordmark"),
    COriginalIcon = require("./c/original"),
    CPlainIcon = require("./c/plain"),
    CLineIcon = require("./c/line"),
    CakephpOriginalIcon = require("./cakephp/original"),
    CakephpOriginalWordmarkIcon = require("./cakephp/original-wordmark"),
    CakephpPlainIcon = require("./cakephp/plain"),
    CakephpPlainWordmarkIcon = require("./cakephp/plain-wordmark"),
    CanvaOriginalIcon = require("./canva/original"),
    CentosOriginalIcon = require("./centos/original"),
    CentosOriginalWordmarkIcon = require("./centos/original-wordmark"),
    CentosPlainIcon = require("./centos/plain"),
    CentosPlainWordmarkIcon = require("./centos/plain-wordmark"),
    CeylonOriginalIcon = require("./ceylon/original"),
    CeylonOriginalWordmarkIcon = require("./ceylon/original-wordmark"),
    CeylonPlainIcon = require("./ceylon/plain"),
    CeylonPlainWordmarkIcon = require("./ceylon/plain-wordmark"),
    ChromeOriginalIcon = require("./chrome/original"),
    ChromeOriginalWordmarkIcon = require("./chrome/original-wordmark"),
    ChromePlainIcon = require("./chrome/plain"),
    ChromePlainWordmarkIcon = require("./chrome/plain-wordmark"),
    CircleciPlainIcon = require("./circleci/plain"),
    CircleciPlainWordmarkIcon = require("./circleci/plain-wordmark"),
    ClojureOriginalIcon = require("./clojure/original"),
    ClojureLineIcon = require("./clojure/line"),
    ClojurescriptOriginalIcon = require("./clojurescript/original"),
    ClojurescriptPlainIcon = require("./clojurescript/plain"),
    CodecovPlainIcon = require("./codecov/plain"),
    CodeigniterPlainIcon = require("./codeigniter/plain"),
    CodeigniterPlainWordmarkIcon = require("./codeigniter/plain-wordmark"),
    CodepenPlainIcon = require("./codepen/plain"),
    CodepenOriginalWordmarkIcon = require("./codepen/original-wordmark"),
    CoffeescriptOriginalIcon = require("./coffeescript/original"),
    CoffeescriptOriginalWordmarkIcon = require("./coffeescript/original-wordmark"),
    ConfluenceOriginalIcon = require("./confluence/original"),
    ConfluenceOriginalWordmarkIcon = require("./confluence/original-wordmark"),
    CouchdbOriginalIcon = require("./couchdb/original"),
    CouchdbOriginalWordmarkIcon = require("./couchdb/original-wordmark"),
    CplusplusPlainIcon = require("./cplusplus/plain"),
    CplusplusLineIcon = require("./cplusplus/line"),
    CsharpOriginalIcon = require("./csharp/original"),
    CsharpPlainIcon = require("./csharp/plain"),
    CsharpLineIcon = require("./csharp/line"),
    Css3OriginalIcon = require("./css3/original"),
    Css3OriginalWordmarkIcon = require("./css3/original-wordmark"),
    Css3PlainIcon = require("./css3/plain"),
    Css3PlainWordmarkIcon = require("./css3/plain-wordmark"),
    CucumberPlainIcon = require("./cucumber/plain"),
    CucumberPlainWordmarkIcon = require("./cucumber/plain-wordmark"),
    CrystalOriginalIcon = require("./crystal/original"),
    CrystalOriginalWordmarkIcon = require("./crystal/original-wordmark"),
    D3jsOriginalIcon = require("./d3js/original"),
    D3jsPlainIcon = require("./d3js/plain"),
    DartOriginalIcon = require("./dart/original"),
    DartOriginalWordmarkIcon = require("./dart/original-wordmark"),
    DartPlainIcon = require("./dart/plain"),
    DartPlainWordmarkIcon = require("./dart/plain-wordmark"),
    DebianOriginalIcon = require("./debian/original"),
    DebianOriginalWordmarkIcon = require("./debian/original-wordmark"),
    DebianPlainIcon = require("./debian/plain"),
    DebianPlainWordmarkIcon = require("./debian/plain-wordmark"),
    DenojsOriginalIcon = require("./denojs/original"),
    DenojsOriginalWordmarkIcon = require("./denojs/original-wordmark"),
    DeviconOriginalIcon = require("./devicon/original"),
    DeviconOriginalWordmarkIcon = require("./devicon/original-wordmark"),
    DeviconPlainIcon = require("./devicon/plain"),
    DeviconPlainWordmarkIcon = require("./devicon/plain-wordmark"),
    DeviconLineIcon = require("./devicon/line"),
    DjangoOriginalIcon = require("./django/original"),
    DjangoPlainIcon = require("./django/plain"),
    DjangoLineIcon = require("./django/line"),
    DockerOriginalIcon = require("./docker/original"),
    DockerOriginalWordmarkIcon = require("./docker/original-wordmark"),
    DockerPlainIcon = require("./docker/plain"),
    DockerPlainWordmarkIcon = require("./docker/plain-wordmark"),
    DoctrineOriginalIcon = require("./doctrine/original"),
    DoctrineOriginalWordmarkIcon = require("./doctrine/original-wordmark"),
    DoctrinePlainIcon = require("./doctrine/plain"),
    DoctrinePlainWordmarkIcon = require("./doctrine/plain-wordmark"),
    DoctrineLineIcon = require("./doctrine/line"),
    DoctrineLineWordmarkIcon = require("./doctrine/line-wordmark"),
    DotNetOriginalIcon = require("./dot-net/original"),
    DotNetPlainIcon = require("./dot-net/plain"),
    DotNetPlainWordmarkIcon = require("./dot-net/plain-wordmark"),
    DotnetcoreOriginalIcon = require("./dotnetcore/original"),
    DotnetcorePlainIcon = require("./dotnetcore/plain"),
    DrupalOriginalIcon = require("./drupal/original"),
    DrupalOriginalWordmarkIcon = require("./drupal/original-wordmark"),
    DrupalPlainIcon = require("./drupal/plain"),
    DrupalPlainWordmarkIcon = require("./drupal/plain-wordmark"),
    DigitaloceanOriginalIcon = require("./digitalocean/original"),
    DigitaloceanOriginalWordmarkIcon = require("./digitalocean/original-wordmark"),
    DigitaloceanPlainIcon = require("./digitalocean/plain"),
    DigitaloceanPlainWordmarkIcon = require("./digitalocean/plain-wordmark"),
    ElectronOriginalIcon = require("./electron/original"),
    ElectronOriginalWordmarkIcon = require("./electron/original-wordmark"),
    EleventyOriginalIcon = require("./eleventy/original"),
    EleventyPlainIcon = require("./eleventy/plain"),
    ElixirOriginalIcon = require("./elixir/original"),
    ElixirOriginalWordmarkIcon = require("./elixir/original-wordmark"),
    ElixirPlainIcon = require("./elixir/plain"),
    ElixirPlainWordmarkIcon = require("./elixir/plain-wordmark"),
    ElmOriginalIcon = require("./elm/original"),
    ElmOriginalWordmarkIcon = require("./elm/original-wordmark"),
    ElmPlainIcon = require("./elm/plain"),
    ElmPlainWordmarkIcon = require("./elm/plain-wordmark"),
    EmberOriginalWordmarkIcon = require("./ember/original-wordmark"),
    EmbeddedcOriginalIcon = require("./embeddedc/original"),
    EmbeddedcOriginalWordmarkIcon = require("./embeddedc/original-wordmark"),
    EmbeddedcPlainIcon = require("./embeddedc/plain"),
    EmbeddedcPlainWordmarkIcon = require("./embeddedc/plain-wordmark"),
    ErlangOriginalIcon = require("./erlang/original"),
    ErlangOriginalWordmarkIcon = require("./erlang/original-wordmark"),
    ErlangPlainIcon = require("./erlang/plain"),
    ErlangPlainWordmarkIcon = require("./erlang/plain-wordmark"),
    ExpressOriginalIcon = require("./express/original"),
    ExpressOriginalWordmarkIcon = require("./express/original-wordmark"),
    FacebookOriginalIcon = require("./facebook/original"),
    FacebookPlainIcon = require("./facebook/plain"),
    FeathersjsOriginalIcon = require("./feathersjs/original"),
    FigmaOriginalIcon = require("./figma/original"),
    FigmaPlainIcon = require("./figma/plain"),
    FilezillaPlainIcon = require("./filezilla/plain"),
    FilezillaPlainWordmarkIcon = require("./filezilla/plain-wordmark"),
    FirebasePlainIcon = require("./firebase/plain"),
    FirebasePlainWordmarkIcon = require("./firebase/plain-wordmark"),
    FirefoxPlainIcon = require("./firefox/plain"),
    FirefoxPlainWordmarkIcon = require("./firefox/plain-wordmark"),
    FlaskOriginalIcon = require("./flask/original"),
    FlaskOriginalWordmarkIcon = require("./flask/original-wordmark"),
    FlutterOriginalIcon = require("./flutter/original"),
    FlutterPlainIcon = require("./flutter/plain"),
    FoundationPlainIcon = require("./foundation/plain"),
    FoundationPlainWordmarkIcon = require("./foundation/plain-wordmark"),
    FsharpOriginalIcon = require("./fsharp/original"),
    FsharpPlainIcon = require("./fsharp/plain"),
    GatlingPlainIcon = require("./gatling/plain"),
    GatlingPlainWordmarkIcon = require("./gatling/plain-wordmark"),
    GatsbyPlainIcon = require("./gatsby/plain"),
    GatsbyOriginalIcon = require("./gatsby/original"),
    GatsbyOriginalWordmarkIcon = require("./gatsby/original-wordmark"),
    GatsbyPlainWordmarkIcon = require("./gatsby/plain-wordmark"),
    GccOriginalIcon = require("./gcc/original"),
    GccPlainIcon = require("./gcc/plain"),
    GimpOriginalIcon = require("./gimp/original"),
    GimpOriginalWordmarkIcon = require("./gimp/original-wordmark"),
    GimpPlainIcon = require("./gimp/plain"),
    GimpPlainWordmarkIcon = require("./gimp/plain-wordmark"),
    GitOriginalIcon = require("./git/original"),
    GitOriginalWordmarkIcon = require("./git/original-wordmark"),
    GitPlainIcon = require("./git/plain"),
    GitPlainWordmarkIcon = require("./git/plain-wordmark"),
    GithubOriginalIcon = require("./github/original"),
    GithubOriginalWordmarkIcon = require("./github/original-wordmark"),
    GitlabOriginalIcon = require("./gitlab/original"),
    GitlabOriginalWordmarkIcon = require("./gitlab/original-wordmark"),
    GitlabPlainIcon = require("./gitlab/plain"),
    GitlabPlainWordmarkIcon = require("./gitlab/plain-wordmark"),
    GitterPlainIcon = require("./gitter/plain"),
    GitterPlainWordmarkIcon = require("./gitter/plain-wordmark"),
    GoOriginalIcon = require("./go/original"),
    GoOriginalWordmarkIcon = require("./go/original-wordmark"),
    GoPlainIcon = require("./go/plain"),
    GoLineIcon = require("./go/line"),
    GoogleOriginalIcon = require("./google/original"),
    GoogleOriginalWordmarkIcon = require("./google/original-wordmark"),
    GooglePlainIcon = require("./google/plain"),
    GooglePlainWordmarkIcon = require("./google/plain-wordmark"),
    GooglecloudOriginalIcon = require("./googlecloud/original"),
    GooglecloudOriginalWordmarkIcon = require("./googlecloud/original-wordmark"),
    GooglecloudPlainIcon = require("./googlecloud/plain"),
    GooglecloudPlainWordmarkIcon = require("./googlecloud/plain-wordmark"),
    GradlePlainIcon = require("./gradle/plain"),
    GradlePlainWordmarkIcon = require("./gradle/plain-wordmark"),
    GrailsOriginalIcon = require("./grails/original"),
    GrailsPlainIcon = require("./grails/plain"),
    GraphqlPlainIcon = require("./graphql/plain"),
    GraphqlPlainWordmarkIcon = require("./graphql/plain-wordmark"),
    GroovyPlainIcon = require("./groovy/plain"),
    GruntPlainIcon = require("./grunt/plain"),
    GruntPlainWordmarkIcon = require("./grunt/plain-wordmark"),
    GruntLineIcon = require("./grunt/line"),
    GruntLineWordmarkIcon = require("./grunt/line-wordmark"),
    GulpPlainIcon = require("./gulp/plain"),
    GodotOriginalIcon = require("./godot/original"),
    GodotOriginalWordmarkIcon = require("./godot/original-wordmark"),
    GodotPlainIcon = require("./godot/plain"),
    GodotPlainWordmarkIcon = require("./godot/plain-wordmark"),
    HaskellOriginalIcon = require("./haskell/original"),
    HaskellOriginalWordmarkIcon = require("./haskell/original-wordmark"),
    HaskellPlainIcon = require("./haskell/plain"),
    HaskellPlainWordmarkIcon = require("./haskell/plain-wordmark"),
    HandlebarsOriginalIcon = require("./handlebars/original"),
    HandlebarsOriginalWordmarkIcon = require("./handlebars/original-wordmark"),
    HaxeOriginalIcon = require("./haxe/original"),
    HaxePlainIcon = require("./haxe/plain"),
    HerokuOriginalIcon = require("./heroku/original"),
    HerokuOriginalWordmarkIcon = require("./heroku/original-wordmark"),
    HerokuPlainIcon = require("./heroku/plain"),
    HerokuPlainWordmarkIcon = require("./heroku/plain-wordmark"),
    Html5OriginalIcon = require("./html5/original"),
    Html5OriginalWordmarkIcon = require("./html5/original-wordmark"),
    Html5PlainIcon = require("./html5/plain"),
    Html5PlainWordmarkIcon = require("./html5/plain-wordmark"),
    Ie10OriginalIcon = require("./ie10/original"),
    IllustratorPlainIcon = require("./illustrator/plain"),
    IllustratorLineIcon = require("./illustrator/line"),
    InkscapeOriginalIcon = require("./inkscape/original"),
    InkscapePlainIcon = require("./inkscape/plain"),
    InkscapePlainWordmarkIcon = require("./inkscape/plain-wordmark"),
    IntellijOriginalIcon = require("./intellij/original"),
    IntellijOriginalWordmarkIcon = require("./intellij/original-wordmark"),
    IntellijPlainIcon = require("./intellij/plain"),
    IntellijPlainWordmarkIcon = require("./intellij/plain-wordmark"),
    IonicOriginalIcon = require("./ionic/original"),
    IonicOriginalWordmarkIcon = require("./ionic/original-wordmark"),
    JamstackOriginalIcon = require("./jamstack/original"),
    JamstackOriginalWordmarkIcon = require("./jamstack/original-wordmark"),
    JamstackPlainWordmarkIcon = require("./jamstack/plain-wordmark"),
    JasminePlainIcon = require("./jasmine/plain"),
    JasminePlainWordmarkIcon = require("./jasmine/plain-wordmark"),
    JavaOriginalIcon = require("./java/original"),
    JavaOriginalWordmarkIcon = require("./java/original-wordmark"),
    JavaPlainIcon = require("./java/plain"),
    JavaPlainWordmarkIcon = require("./java/plain-wordmark"),
    JavascriptOriginalIcon = require("./javascript/original"),
    JavascriptPlainIcon = require("./javascript/plain"),
    JeetOriginalIcon = require("./jeet/original"),
    JeetOriginalWordmarkIcon = require("./jeet/original-wordmark"),
    JeetPlainIcon = require("./jeet/plain"),
    JeetPlainWordmarkIcon = require("./jeet/plain-wordmark"),
    JestPlainIcon = require("./jest/plain"),
    JenkinsLineIcon = require("./jenkins/line"),
    JenkinsPlainIcon = require("./jenkins/plain"),
    JetbrainsOriginalIcon = require("./jetbrains/original"),
    JetbrainsPlainIcon = require("./jetbrains/plain"),
    JiraOriginalIcon = require("./jira/original"),
    JiraOriginalWordmarkIcon = require("./jira/original-wordmark"),
    JiraPlainIcon = require("./jira/plain"),
    JiraPlainWordmarkIcon = require("./jira/plain-wordmark"),
    JqueryOriginalIcon = require("./jquery/original"),
    JqueryOriginalWordmarkIcon = require("./jquery/original-wordmark"),
    JqueryPlainIcon = require("./jquery/plain"),
    JqueryPlainWordmarkIcon = require("./jquery/plain-wordmark"),
    JuliaOriginalIcon = require("./julia/original"),
    JuliaOriginalWordmarkIcon = require("./julia/original-wordmark"),
    JuliaPlainIcon = require("./julia/plain"),
    JuliaPlainWordmarkIcon = require("./julia/plain-wordmark"),
    JupyterOriginalIcon = require("./jupyter/original"),
    JupyterOriginalWordmarkIcon = require("./jupyter/original-wordmark"),
    JupyterPlainIcon = require("./jupyter/plain"),
    JupyterPlainWordmarkIcon = require("./jupyter/plain-wordmark"),
    KarmaOriginalIcon = require("./karma/original"),
    KarmaPlainIcon = require("./karma/plain"),
    KotlinOriginalIcon = require("./kotlin/original"),
    KotlinOriginalWordmarkIcon = require("./kotlin/original-wordmark"),
    KotlinPlainIcon = require("./kotlin/plain"),
    KotlinPlainWordmarkIcon = require("./kotlin/plain-wordmark"),
    KnockoutPlainWordmarkIcon = require("./knockout/plain-wordmark"),
    KrakenjsOriginalIcon = require("./krakenjs/original"),
    KrakenjsOriginalWordmarkIcon = require("./krakenjs/original-wordmark"),
    KrakenjsPlainIcon = require("./krakenjs/plain"),
    KrakenjsPlainWordmarkIcon = require("./krakenjs/plain-wordmark"),
    KubernetesPlainIcon = require("./kubernetes/plain"),
    KubernetesPlainWordmarkIcon = require("./kubernetes/plain-wordmark"),
    LabviewOriginalIcon = require("./labview/original"),
    LabviewOriginalWordmarkIcon = require("./labview/original-wordmark"),
    LabviewPlainIcon = require("./labview/plain"),
    LabviewPlainWordmarkIcon = require("./labview/plain-wordmark"),
    LaravelPlainIcon = require("./laravel/plain"),
    LaravelPlainWordmarkIcon = require("./laravel/plain-wordmark"),
    LessPlainWordmarkIcon = require("./less/plain-wordmark"),
    LinkedinOriginalIcon = require("./linkedin/original"),
    LinkedinOriginalWordmarkIcon = require("./linkedin/original-wordmark"),
    LinkedinPlainIcon = require("./linkedin/plain"),
    LinkedinPlainWordmarkIcon = require("./linkedin/plain-wordmark"),
    LuaOriginalIcon = require("./lua/original"),
    LuaOriginalWordmarkIcon = require("./lua/original-wordmark"),
    LuaPlainIcon = require("./lua/plain"),
    LuaPlainWordmarkIcon = require("./lua/plain-wordmark"),
    LinuxPlainIcon = require("./linux/plain"),
    MaterialuiOriginalIcon = require("./materialui/original"),
    MaterialuiPlainIcon = require("./materialui/plain"),
    MatlabOriginalIcon = require("./matlab/original"),
    MatlabPlainIcon = require("./matlab/plain"),
    MatlabLineIcon = require("./matlab/line"),
    MagentoOriginalIcon = require("./magento/original"),
    MagentoOriginalWordmarkIcon = require("./magento/original-wordmark"),
    MagentoLineIcon = require("./magento/line"),
    MarkdownOriginalIcon = require("./markdown/original"),
    MeteorOriginalIcon = require("./meteor/original"),
    MeteorOriginalWordmarkIcon = require("./meteor/original-wordmark"),
    MeteorPlainIcon = require("./meteor/plain"),
    MeteorPlainWordmarkIcon = require("./meteor/plain-wordmark"),
    MinitabOriginalIcon = require("./minitab/original"),
    MinitabPlainIcon = require("./minitab/plain"),
    MochaPlainIcon = require("./mocha/plain"),
    ModxOriginalIcon = require("./modx/original"),
    ModxOriginalWordmarkIcon = require("./modx/original-wordmark"),
    ModxPlainIcon = require("./modx/plain"),
    ModxPlainWordmarkIcon = require("./modx/plain-wordmark"),
    MongodbOriginalIcon = require("./mongodb/original"),
    MongodbOriginalWordmarkIcon = require("./mongodb/original-wordmark"),
    MongodbPlainIcon = require("./mongodb/plain"),
    MongodbPlainWordmarkIcon = require("./mongodb/plain-wordmark"),
    MoodleOriginalIcon = require("./moodle/original"),
    MoodleOriginalWordmarkIcon = require("./moodle/original-wordmark"),
    MoodlePlainIcon = require("./moodle/plain"),
    MoodlePlainWordmarkIcon = require("./moodle/plain-wordmark"),
    MsdosOriginalIcon = require("./msdos/original"),
    MsdosPlainIcon = require("./msdos/plain"),
    MsdosLineIcon = require("./msdos/line"),
    MysqlOriginalIcon = require("./mysql/original"),
    MysqlOriginalWordmarkIcon = require("./mysql/original-wordmark"),
    MysqlPlainIcon = require("./mysql/plain"),
    MysqlPlainWordmarkIcon = require("./mysql/plain-wordmark"),
    Neo4jOriginalIcon = require("./neo4j/original"),
    Neo4jOriginalWordmarkIcon = require("./neo4j/original-wordmark"),
    Neo4jPlainIcon = require("./neo4j/plain"),
    Neo4jPlainWordmarkIcon = require("./neo4j/plain-wordmark"),
    NestjsPlainIcon = require("./nestjs/plain"),
    NestjsPlainWordmarkIcon = require("./nestjs/plain-wordmark"),
    NextjsOriginalIcon = require("./nextjs/original"),
    NextjsLineIcon = require("./nextjs/line"),
    NextjsOriginalWordmarkIcon = require("./nextjs/original-wordmark"),
    NginxOriginalIcon = require("./nginx/original"),
    NixosOriginalIcon = require("./nixos/original"),
    NixosOriginalWordmarkIcon = require("./nixos/original-wordmark"),
    NixosPlainIcon = require("./nixos/plain"),
    NixosPlainWordmarkIcon = require("./nixos/plain-wordmark"),
    NodejsOriginalIcon = require("./nodejs/original"),
    NodejsOriginalWordmarkIcon = require("./nodejs/original-wordmark"),
    NodejsPlainIcon = require("./nodejs/plain"),
    NodejsPlainWordmarkIcon = require("./nodejs/plain-wordmark"),
    NodewebkitOriginalIcon = require("./nodewebkit/original"),
    NodewebkitOriginalWordmarkIcon = require("./nodewebkit/original-wordmark"),
    NodewebkitPlainIcon = require("./nodewebkit/plain"),
    NodewebkitPlainWordmarkIcon = require("./nodewebkit/plain-wordmark"),
    NodewebkitLineIcon = require("./nodewebkit/line"),
    NodewebkitLineWordmarkIcon = require("./nodewebkit/line-wordmark"),
    NpmOriginalWordmarkIcon = require("./npm/original-wordmark"),
    NumpyOriginalIcon = require("./numpy/original"),
    NumpyOriginalWordmarkIcon = require("./numpy/original-wordmark"),
    NuxtjsOriginalIcon = require("./nuxtjs/original"),
    NuxtjsOriginalWordmarkIcon = require("./nuxtjs/original-wordmark"),
    NuxtjsPlainIcon = require("./nuxtjs/plain"),
    NuxtjsPlainWordmarkIcon = require("./nuxtjs/plain-wordmark"),
    ObjectivecPlainIcon = require("./objectivec/plain"),
    OperaOriginalIcon = require("./opera/original"),
    OperaOriginalWordmarkIcon = require("./opera/original-wordmark"),
    OperaPlainIcon = require("./opera/plain"),
    OperaPlainWordmarkIcon = require("./opera/plain-wordmark"),
    OcamlOriginalIcon = require("./ocaml/original"),
    OcamlOriginalWordmarkIcon = require("./ocaml/original-wordmark"),
    OcamlPlainIcon = require("./ocaml/plain"),
    OcamlPlainWordmarkIcon = require("./ocaml/plain-wordmark"),
    OpenglOriginalIcon = require("./opengl/original"),
    OpenglPlainIcon = require("./opengl/plain"),
    OracleOriginalIcon = require("./oracle/original"),
    PandasOriginalIcon = require("./pandas/original"),
    PandasOriginalWordmarkIcon = require("./pandas/original-wordmark"),
    PerlOriginalIcon = require("./perl/original"),
    PerlPlainIcon = require("./perl/plain"),
    PhalconOriginalIcon = require("./phalcon/original"),
    PhalconPlainIcon = require("./phalcon/plain"),
    PhotoshopPlainIcon = require("./photoshop/plain"),
    PhotoshopLineIcon = require("./photoshop/line"),
    PhpPlainIcon = require("./php/plain"),
    PhpstormOriginalIcon = require("./phpstorm/original"),
    PhpstormOriginalWordmarkIcon = require("./phpstorm/original-wordmark"),
    PhpstormPlainIcon = require("./phpstorm/plain"),
    PhpstormPlainWordmarkIcon = require("./phpstorm/plain-wordmark"),
    PostgresqlOriginalIcon = require("./postgresql/original"),
    PostgresqlOriginalWordmarkIcon = require("./postgresql/original-wordmark"),
    PostgresqlPlainIcon = require("./postgresql/plain"),
    PostgresqlPlainWordmarkIcon = require("./postgresql/plain-wordmark"),
    PremiereproPlainIcon = require("./premierepro/plain"),
    PremiereproOriginalIcon = require("./premierepro/original"),
    ProcessingOriginalIcon = require("./processing/original"),
    ProcessingOriginalWordmarkIcon = require("./processing/original-wordmark"),
    ProcessingPlainIcon = require("./processing/plain"),
    ProcessingPlainWordmarkIcon = require("./processing/plain-wordmark"),
    ProtractorPlainIcon = require("./protractor/plain"),
    ProtractorPlainWordmarkIcon = require("./protractor/plain-wordmark"),
    PuttyOriginalIcon = require("./putty/original"),
    PuttyPlainIcon = require("./putty/plain"),
    PycharmOriginalIcon = require("./pycharm/original"),
    PycharmOriginalWordmarkIcon = require("./pycharm/original-wordmark"),
    PycharmPlainIcon = require("./pycharm/plain"),
    PycharmPlainWordmarkIcon = require("./pycharm/plain-wordmark"),
    PythonOriginalIcon = require("./python/original"),
    PythonOriginalWordmarkIcon = require("./python/original-wordmark"),
    PythonPlainIcon = require("./python/plain"),
    PythonPlainWordmarkIcon = require("./python/plain-wordmark"),
    RaspberrypiOriginalIcon = require("./raspberrypi/original"),
    RaspberrypiOriginalWordmarkIcon = require("./raspberrypi/original-wordmark"),
    RaspberrypiLineIcon = require("./raspberrypi/line"),
    RaspberrypiLineWordmarkIcon = require("./raspberrypi/line-wordmark"),
    PhoenixOriginalIcon = require("./phoenix/original"),
    PhoenixOriginalWordmarkIcon = require("./phoenix/original-wordmark"),
    PhoenixPlainIcon = require("./phoenix/plain"),
    PhoenixPlainWordmarkIcon = require("./phoenix/plain-wordmark"),
    QtOriginalIcon = require("./qt/original"),
    ROriginalIcon = require("./r/original"),
    RPlainIcon = require("./r/plain"),
    RailsOriginalWordmarkIcon = require("./rails/original-wordmark"),
    RailsPlainIcon = require("./rails/plain"),
    RailsPlainWordmarkIcon = require("./rails/plain-wordmark"),
    ReactOriginalIcon = require("./react/original"),
    ReactOriginalWordmarkIcon = require("./react/original-wordmark"),
    RedhatOriginalIcon = require("./redhat/original"),
    RedhatOriginalWordmarkIcon = require("./redhat/original-wordmark"),
    RedhatPlainIcon = require("./redhat/plain"),
    RedhatPlainWordmarkIcon = require("./redhat/plain-wordmark"),
    RedisOriginalIcon = require("./redis/original"),
    RedisOriginalWordmarkIcon = require("./redis/original-wordmark"),
    RedisPlainIcon = require("./redis/plain"),
    RedisPlainWordmarkIcon = require("./redis/plain-wordmark"),
    ReduxOriginalIcon = require("./redux/original"),
    RocksdbPlainIcon = require("./rocksdb/plain"),
    RubyOriginalIcon = require("./ruby/original"),
    RubyOriginalWordmarkIcon = require("./ruby/original-wordmark"),
    RubyPlainIcon = require("./ruby/plain"),
    RubyPlainWordmarkIcon = require("./ruby/plain-wordmark"),
    RubymineOriginalIcon = require("./rubymine/original"),
    RubymineOriginalWordmarkIcon = require("./rubymine/original-wordmark"),
    RubyminePlainIcon = require("./rubymine/plain"),
    RubyminePlainWordmarkIcon = require("./rubymine/plain-wordmark"),
    RustPlainIcon = require("./rust/plain"),
    SafariOriginalIcon = require("./safari/original"),
    SafariOriginalWordmarkIcon = require("./safari/original-wordmark"),
    SafariPlainIcon = require("./safari/plain"),
    SafariPlainWordmarkIcon = require("./safari/plain-wordmark"),
    SafariLineWordmarkIcon = require("./safari/line-wordmark"),
    SafariLineIcon = require("./safari/line"),
    SalesforceOriginalIcon = require("./salesforce/original"),
    SalesforcePlainIcon = require("./salesforce/plain"),
    RstudioOriginalIcon = require("./rstudio/original"),
    RstudioPlainIcon = require("./rstudio/plain"),
    SassOriginalIcon = require("./sass/original"),
    ScalaOriginalIcon = require("./scala/original"),
    ScalaOriginalWordmarkIcon = require("./scala/original-wordmark"),
    ScalaPlainIcon = require("./scala/plain"),
    ScalaPlainWordmarkIcon = require("./scala/plain-wordmark"),
    SequelizeOriginalIcon = require("./sequelize/original"),
    SequelizeOriginalWordmarkIcon = require("./sequelize/original-wordmark"),
    SequelizePlainIcon = require("./sequelize/plain"),
    SequelizePlainWordmarkIcon = require("./sequelize/plain-wordmark"),
    ShopwareOriginalIcon = require("./shopware/original"),
    ShopwareOriginalWordmarkIcon = require("./shopware/original-wordmark"),
    SketchOriginalIcon = require("./sketch/original"),
    SketchOriginalWordmarkIcon = require("./sketch/original-wordmark"),
    SketchLineIcon = require("./sketch/line"),
    SketchLineWordmarkIcon = require("./sketch/line-wordmark"),
    SlackOriginalIcon = require("./slack/original"),
    SlackOriginalWordmarkIcon = require("./slack/original-wordmark"),
    SlackPlainIcon = require("./slack/plain"),
    SlackPlainWordmarkIcon = require("./slack/plain-wordmark"),
    SocketioOriginalIcon = require("./socketio/original"),
    SocketioOriginalWordmarkIcon = require("./socketio/original-wordmark"),
    SourcetreeOriginalIcon = require("./sourcetree/original"),
    SourcetreeOriginalWordmarkIcon = require("./sourcetree/original-wordmark"),
    SpringOriginalIcon = require("./spring/original"),
    SpringOriginalWordmarkIcon = require("./spring/original-wordmark"),
    SpringPlainIcon = require("./spring/plain"),
    SpringPlainWordmarkIcon = require("./spring/plain-wordmark"),
    SpssOriginalIcon = require("./spss/original"),
    SpssPlainIcon = require("./spss/plain"),
    SqlalchemyOriginalIcon = require("./sqlalchemy/original"),
    SqlalchemyOriginalWordmarkIcon = require("./sqlalchemy/original-wordmark"),
    SqlalchemyPlainIcon = require("./sqlalchemy/plain"),
    SubversionOriginalIcon = require("./subversion/original"),
    SubversionOriginalWordmarkIcon = require("./subversion/original-wordmark"),
    MicrosoftsqlserverPlainIcon = require("./microsoftsqlserver/plain"),
    MicrosoftsqlserverPlainWordmarkIcon = require("./microsoftsqlserver/plain-wordmark"),
    SshOriginalIcon = require("./ssh/original"),
    SshOriginalWordmarkIcon = require("./ssh/original-wordmark"),
    StylusOriginalIcon = require("./stylus/original"),
    SvelteOriginalIcon = require("./svelte/original"),
    SvelteOriginalWordmarkIcon = require("./svelte/original-wordmark"),
    SveltePlainIcon = require("./svelte/plain"),
    SveltePlainWordmarkIcon = require("./svelte/plain-wordmark"),
    SwiftOriginalIcon = require("./swift/original"),
    SwiftOriginalWordmarkIcon = require("./swift/original-wordmark"),
    SwiftPlainIcon = require("./swift/plain"),
    SwiftPlainWordmarkIcon = require("./swift/plain-wordmark"),
    SymfonyOriginalIcon = require("./symfony/original"),
    SymfonyOriginalWordmarkIcon = require("./symfony/original-wordmark"),
    StorybookOriginalIcon = require("./storybook/original"),
    StorybookOriginalWordmarkIcon = require("./storybook/original-wordmark"),
    StorybookPlainIcon = require("./storybook/plain"),
    StorybookPlainWordmarkIcon = require("./storybook/plain-wordmark"),
    TailwindcssOriginalWordmarkIcon = require("./tailwindcss/original-wordmark"),
    TailwindcssPlainIcon = require("./tailwindcss/plain"),
    TensorflowOriginalIcon = require("./tensorflow/original"),
    TensorflowLineIcon = require("./tensorflow/line"),
    ThreejsOriginalIcon = require("./threejs/original"),
    ThreejsOriginalWordmarkIcon = require("./threejs/original-wordmark"),
    TomcatOriginalIcon = require("./tomcat/original"),
    TomcatOriginalWordmarkIcon = require("./tomcat/original-wordmark"),
    TomcatLineIcon = require("./tomcat/line"),
    TomcatLineWordmarkIcon = require("./tomcat/line-wordmark"),
    TortoisegitPlainIcon = require("./tortoisegit/plain"),
    TortoisegitLineIcon = require("./tortoisegit/line"),
    TowergitOriginalIcon = require("./towergit/original"),
    TowergitOriginalWordmarkIcon = require("./towergit/original-wordmark"),
    TowergitPlainIcon = require("./towergit/plain"),
    TowergitPlainWordmarkIcon = require("./towergit/plain-wordmark"),
    TravisPlainIcon = require("./travis/plain"),
    TravisPlainWordmarkIcon = require("./travis/plain-wordmark"),
    ThealgorithmsOriginalIcon = require("./thealgorithms/original"),
    ThealgorithmsOriginalWordmarkIcon = require("./thealgorithms/original-wordmark"),
    ThealgorithmsPlainIcon = require("./thealgorithms/plain"),
    ThealgorithmsPlainWordmarkIcon = require("./thealgorithms/plain-wordmark"),
    TrelloPlainIcon = require("./trello/plain"),
    TrelloPlainWordmarkIcon = require("./trello/plain-wordmark"),
    TwitterOriginalIcon = require("./twitter/original"),
    TypescriptOriginalIcon = require("./typescript/original"),
    TypescriptPlainIcon = require("./typescript/plain"),
    Typo3OriginalIcon = require("./typo3/original"),
    Typo3OriginalWordmarkIcon = require("./typo3/original-wordmark"),
    Typo3PlainIcon = require("./typo3/plain"),
    Typo3PlainWordmarkIcon = require("./typo3/plain-wordmark"),
    UbuntuPlainIcon = require("./ubuntu/plain"),
    UbuntuPlainWordmarkIcon = require("./ubuntu/plain-wordmark"),
    UnityOriginalIcon = require("./unity/original"),
    UnityOriginalWordmarkIcon = require("./unity/original-wordmark"),
    UnixOriginalIcon = require("./unix/original"),
    UwsgiOriginalIcon = require("./uwsgi/original"),
    UwsgiPlainIcon = require("./uwsgi/plain"),
    VagrantOriginalIcon = require("./vagrant/original"),
    VagrantOriginalWordmarkIcon = require("./vagrant/original-wordmark"),
    VagrantPlainIcon = require("./vagrant/plain"),
    VagrantPlainWordmarkIcon = require("./vagrant/plain-wordmark"),
    VimOriginalIcon = require("./vim/original"),
    VimPlainIcon = require("./vim/plain"),
    VisualstudioPlainIcon = require("./visualstudio/plain"),
    VisualstudioPlainWordmarkIcon = require("./visualstudio/plain-wordmark"),
    VuejsOriginalIcon = require("./vuejs/original"),
    VuejsOriginalWordmarkIcon = require("./vuejs/original-wordmark"),
    VuejsPlainIcon = require("./vuejs/plain"),
    VuejsPlainWordmarkIcon = require("./vuejs/plain-wordmark"),
    VuejsLineIcon = require("./vuejs/line"),
    VuejsLineWordmarkIcon = require("./vuejs/line-wordmark"),
    VuestorefrontOriginalIcon = require("./vuestorefront/original"),
    VuestorefrontPlainIcon = require("./vuestorefront/plain"),
    VscodeOriginalIcon = require("./vscode/original"),
    VscodePlainIcon = require("./vscode/plain"),
    WeblateOriginalIcon = require("./weblate/original"),
    WeblatePlainIcon = require("./weblate/plain"),
    WeblateOriginalWordmarkIcon = require("./weblate/original-wordmark"),
    WeblatePlainWordmarkIcon = require("./weblate/plain-wordmark"),
    WebpackOriginalIcon = require("./webpack/original"),
    WebpackOriginalWordmarkIcon = require("./webpack/original-wordmark"),
    WebpackPlainIcon = require("./webpack/plain"),
    WebpackPlainWordmarkIcon = require("./webpack/plain-wordmark"),
    WebstormOriginalIcon = require("./webstorm/original"),
    WebstormOriginalWordmarkIcon = require("./webstorm/original-wordmark"),
    WebstormPlainIcon = require("./webstorm/plain"),
    WebstormPlainWordmarkIcon = require("./webstorm/plain-wordmark"),
    Windows8OriginalIcon = require("./windows8/original"),
    Windows8OriginalWordmarkIcon = require("./windows8/original-wordmark"),
    WoocommerceOriginalIcon = require("./woocommerce/original"),
    WoocommercePlainIcon = require("./woocommerce/plain"),
    WoocommerceOriginalWordmarkIcon = require("./woocommerce/original-wordmark"),
    WoocommercePlainWordmarkIcon = require("./woocommerce/plain-wordmark"),
    WordpressOriginalIcon = require("./wordpress/original"),
    WordpressPlainIcon = require("./wordpress/plain"),
    WordpressPlainWordmarkIcon = require("./wordpress/plain-wordmark"),
    XdPlainIcon = require("./xd/plain"),
    XdLineIcon = require("./xd/line"),
    YarnOriginalIcon = require("./yarn/original"),
    YarnOriginalWordmarkIcon = require("./yarn/original-wordmark"),
    YiiOriginalIcon = require("./yii/original"),
    YiiPlainIcon = require("./yii/plain"),
    YiiPlainWordmarkIcon = require("./yii/plain-wordmark"),
    YunohostOriginalIcon = require("./yunohost/original"),
    ZendPlainIcon = require("./zend/plain"),
    ZendPlainWordmarkIcon = require("./zend/plain-wordmark"),
    ZigOriginalIcon = require("./zig/original"),
    ZigOriginalWordmarkIcon = require("./zig/original-wordmark"),
    ZigPlainWordmarkIcon = require("./zig/plain-wordmark"),
    BabelOriginalIcon = require("./babel/original"),
    BootstrapOriginalIcon = require("./bootstrap/original"),
    ComposerLineIcon = require("./composer/line"),
    ComposerLineWordmarkIcon = require("./composer/line-wordmark"),
    DeviconLineWordmarkIcon = require("./devicon/line-wordmark"),
    DotNetOriginalWordmarkIcon = require("./dot-net/original-wordmark"),
    FoundationOriginalIcon = require("./foundation/original"),
    FoundationOriginalWordmarkIcon = require("./foundation/original-wordmark"),
    GruntOriginalIcon = require("./grunt/original"),
    GruntOriginalWordmarkIcon = require("./grunt/original-wordmark"),
    InkscapeOriginalWordmarkIcon = require("./inkscape/original-wordmark"),
    JenkinsOriginalIcon = require("./jenkins/original"),
    PhpOriginalIcon = require("./php/original"),
    CplusplusOriginalIcon = require("./cplusplus/original"),
    CouchdbPlainWordmarkIcon = require("./couchdb/plain-wordmark"),
    CouchdbPlainIcon = require("./couchdb/plain"),
    TortoisegitOriginalIcon = require("./tortoisegit/original"),
    VscodeOriginalWordmarkIcon = require("./vscode/original-wordmark"),
    VscodePlainWordmarkIcon = require("./vscode/plain-wordmark"),
    YiiOriginalWordmarkIcon = require("./yii/original-wordmark"),
    ComposerOriginalIcon = require("./composer/original"),
    FirefoxOriginalIcon = require("./firefox/original"),
    FirefoxOriginalWordmarkIcon = require("./firefox/original-wordmark"),
    GroovyOriginalIcon = require("./groovy/original"),
    YunohostPlainIcon = require("./yunohost/plain"),
    ApacheOriginalIcon = require("./apache/original"),
    ApacheOriginalWordmarkIcon = require("./apache/original-wordmark"),
    LinuxOriginalIcon = require("./linux/original"),
    TensorflowOriginalWordmarkIcon = require("./tensorflow/original-wordmark"),
    TensorflowLineWordmarkIcon = require("./tensorflow/line-wordmark");

module.exports = {
  AdonisjsOriginalIcon: AdonisjsOriginalIcon,
  AdonisjsOriginalWordmarkIcon: AdonisjsOriginalWordmarkIcon,
  AftereffectsOriginalIcon: AftereffectsOriginalIcon,
  AftereffectsPlainIcon: AftereffectsPlainIcon,
  AmazonwebservicesOriginalIcon: AmazonwebservicesOriginalIcon,
  AmazonwebservicesOriginalWordmarkIcon: AmazonwebservicesOriginalWordmarkIcon,
  AmazonwebservicesPlainWordmarkIcon: AmazonwebservicesPlainWordmarkIcon,
  AndroidOriginalIcon: AndroidOriginalIcon,
  AndroidOriginalWordmarkIcon: AndroidOriginalWordmarkIcon,
  AndroidPlainIcon: AndroidPlainIcon,
  AndroidPlainWordmarkIcon: AndroidPlainWordmarkIcon,
  Aarch64OriginalIcon: Aarch64OriginalIcon,
  Aarch64PlainIcon: Aarch64PlainIcon,
  AngularjsOriginalIcon: AngularjsOriginalIcon,
  AngularjsOriginalWordmarkIcon: AngularjsOriginalWordmarkIcon,
  AngularjsPlainIcon: AngularjsPlainIcon,
  AngularjsPlainWordmarkIcon: AngularjsPlainWordmarkIcon,
  ApachePlainIcon: ApachePlainIcon,
  ApachePlainWordmarkIcon: ApachePlainWordmarkIcon,
  ApacheLineIcon: ApacheLineIcon,
  ApacheLineWordmarkIcon: ApacheLineWordmarkIcon,
  ApachekafkaOriginalIcon: ApachekafkaOriginalIcon,
  ApachekafkaOriginalWordmarkIcon: ApachekafkaOriginalWordmarkIcon,
  AppceleratorOriginalIcon: AppceleratorOriginalIcon,
  AppceleratorOriginalWordmarkIcon: AppceleratorOriginalWordmarkIcon,
  AppceleratorPlainWordmarkIcon: AppceleratorPlainWordmarkIcon,
  AppleOriginalIcon: AppleOriginalIcon,
  AppwriteOriginalIcon: AppwriteOriginalIcon,
  AppwriteOriginalWordmarkIcon: AppwriteOriginalWordmarkIcon,
  AppwritePlainIcon: AppwritePlainIcon,
  AppwritePlainWordmarkIcon: AppwritePlainWordmarkIcon,
  ArduinoOriginalIcon: ArduinoOriginalIcon,
  ArduinoOriginalWordmarkIcon: ArduinoOriginalWordmarkIcon,
  ArduinoPlainIcon: ArduinoPlainIcon,
  ArduinoPlainWordmarkIcon: ArduinoPlainWordmarkIcon,
  AtomOriginalIcon: AtomOriginalIcon,
  AtomOriginalWordmarkIcon: AtomOriginalWordmarkIcon,
  AzureOriginalIcon: AzureOriginalIcon,
  AzureOriginalWordmarkIcon: AzureOriginalWordmarkIcon,
  AzurePlainIcon: AzurePlainIcon,
  AzurePlainWordmarkIcon: AzurePlainWordmarkIcon,
  BabelPlainIcon: BabelPlainIcon,
  BackbonejsOriginalIcon: BackbonejsOriginalIcon,
  BackbonejsOriginalWordmarkIcon: BackbonejsOriginalWordmarkIcon,
  BackbonejsPlainIcon: BackbonejsPlainIcon,
  BackbonejsPlainWordmarkIcon: BackbonejsPlainWordmarkIcon,
  BashOriginalIcon: BashOriginalIcon,
  BashPlainIcon: BashPlainIcon,
  BehanceOriginalIcon: BehanceOriginalIcon,
  BehanceOriginalWordmarkIcon: BehanceOriginalWordmarkIcon,
  BehancePlainIcon: BehancePlainIcon,
  BehancePlainWordmarkIcon: BehancePlainWordmarkIcon,
  BitbucketOriginalIcon: BitbucketOriginalIcon,
  BitbucketOriginalWordmarkIcon: BitbucketOriginalWordmarkIcon,
  BootstrapPlainIcon: BootstrapPlainIcon,
  BootstrapPlainWordmarkIcon: BootstrapPlainWordmarkIcon,
  BulmaPlainIcon: BulmaPlainIcon,
  BowerOriginalIcon: BowerOriginalIcon,
  BowerOriginalWordmarkIcon: BowerOriginalWordmarkIcon,
  BowerPlainIcon: BowerPlainIcon,
  BowerPlainWordmarkIcon: BowerPlainWordmarkIcon,
  BowerLineIcon: BowerLineIcon,
  BowerLineWordmarkIcon: BowerLineWordmarkIcon,
  COriginalIcon: COriginalIcon,
  CPlainIcon: CPlainIcon,
  CLineIcon: CLineIcon,
  CakephpOriginalIcon: CakephpOriginalIcon,
  CakephpOriginalWordmarkIcon: CakephpOriginalWordmarkIcon,
  CakephpPlainIcon: CakephpPlainIcon,
  CakephpPlainWordmarkIcon: CakephpPlainWordmarkIcon,
  CanvaOriginalIcon: CanvaOriginalIcon,
  CentosOriginalIcon: CentosOriginalIcon,
  CentosOriginalWordmarkIcon: CentosOriginalWordmarkIcon,
  CentosPlainIcon: CentosPlainIcon,
  CentosPlainWordmarkIcon: CentosPlainWordmarkIcon,
  CeylonOriginalIcon: CeylonOriginalIcon,
  CeylonOriginalWordmarkIcon: CeylonOriginalWordmarkIcon,
  CeylonPlainIcon: CeylonPlainIcon,
  CeylonPlainWordmarkIcon: CeylonPlainWordmarkIcon,
  ChromeOriginalIcon: ChromeOriginalIcon,
  ChromeOriginalWordmarkIcon: ChromeOriginalWordmarkIcon,
  ChromePlainIcon: ChromePlainIcon,
  ChromePlainWordmarkIcon: ChromePlainWordmarkIcon,
  CircleciPlainIcon: CircleciPlainIcon,
  CircleciPlainWordmarkIcon: CircleciPlainWordmarkIcon,
  ClojureOriginalIcon: ClojureOriginalIcon,
  ClojureLineIcon: ClojureLineIcon,
  ClojurescriptOriginalIcon: ClojurescriptOriginalIcon,
  ClojurescriptPlainIcon: ClojurescriptPlainIcon,
  CodecovPlainIcon: CodecovPlainIcon,
  CodeigniterPlainIcon: CodeigniterPlainIcon,
  CodeigniterPlainWordmarkIcon: CodeigniterPlainWordmarkIcon,
  CodepenPlainIcon: CodepenPlainIcon,
  CodepenOriginalWordmarkIcon: CodepenOriginalWordmarkIcon,
  CoffeescriptOriginalIcon: CoffeescriptOriginalIcon,
  CoffeescriptOriginalWordmarkIcon: CoffeescriptOriginalWordmarkIcon,
  ConfluenceOriginalIcon: ConfluenceOriginalIcon,
  ConfluenceOriginalWordmarkIcon: ConfluenceOriginalWordmarkIcon,
  CouchdbOriginalIcon: CouchdbOriginalIcon,
  CouchdbOriginalWordmarkIcon: CouchdbOriginalWordmarkIcon,
  CplusplusPlainIcon: CplusplusPlainIcon,
  CplusplusLineIcon: CplusplusLineIcon,
  CsharpOriginalIcon: CsharpOriginalIcon,
  CsharpPlainIcon: CsharpPlainIcon,
  CsharpLineIcon: CsharpLineIcon,
  Css3OriginalIcon: Css3OriginalIcon,
  Css3OriginalWordmarkIcon: Css3OriginalWordmarkIcon,
  Css3PlainIcon: Css3PlainIcon,
  Css3PlainWordmarkIcon: Css3PlainWordmarkIcon,
  CucumberPlainIcon: CucumberPlainIcon,
  CucumberPlainWordmarkIcon: CucumberPlainWordmarkIcon,
  CrystalOriginalIcon: CrystalOriginalIcon,
  CrystalOriginalWordmarkIcon: CrystalOriginalWordmarkIcon,
  D3jsOriginalIcon: D3jsOriginalIcon,
  D3jsPlainIcon: D3jsPlainIcon,
  DartOriginalIcon: DartOriginalIcon,
  DartOriginalWordmarkIcon: DartOriginalWordmarkIcon,
  DartPlainIcon: DartPlainIcon,
  DartPlainWordmarkIcon: DartPlainWordmarkIcon,
  DebianOriginalIcon: DebianOriginalIcon,
  DebianOriginalWordmarkIcon: DebianOriginalWordmarkIcon,
  DebianPlainIcon: DebianPlainIcon,
  DebianPlainWordmarkIcon: DebianPlainWordmarkIcon,
  DenojsOriginalIcon: DenojsOriginalIcon,
  DenojsOriginalWordmarkIcon: DenojsOriginalWordmarkIcon,
  DeviconOriginalIcon: DeviconOriginalIcon,
  DeviconOriginalWordmarkIcon: DeviconOriginalWordmarkIcon,
  DeviconPlainIcon: DeviconPlainIcon,
  DeviconPlainWordmarkIcon: DeviconPlainWordmarkIcon,
  DeviconLineIcon: DeviconLineIcon,
  DjangoOriginalIcon: DjangoOriginalIcon,
  DjangoPlainIcon: DjangoPlainIcon,
  DjangoLineIcon: DjangoLineIcon,
  DockerOriginalIcon: DockerOriginalIcon,
  DockerOriginalWordmarkIcon: DockerOriginalWordmarkIcon,
  DockerPlainIcon: DockerPlainIcon,
  DockerPlainWordmarkIcon: DockerPlainWordmarkIcon,
  DoctrineOriginalIcon: DoctrineOriginalIcon,
  DoctrineOriginalWordmarkIcon: DoctrineOriginalWordmarkIcon,
  DoctrinePlainIcon: DoctrinePlainIcon,
  DoctrinePlainWordmarkIcon: DoctrinePlainWordmarkIcon,
  DoctrineLineIcon: DoctrineLineIcon,
  DoctrineLineWordmarkIcon: DoctrineLineWordmarkIcon,
  DotNetOriginalIcon: DotNetOriginalIcon,
  DotNetPlainIcon: DotNetPlainIcon,
  DotNetPlainWordmarkIcon: DotNetPlainWordmarkIcon,
  DotnetcoreOriginalIcon: DotnetcoreOriginalIcon,
  DotnetcorePlainIcon: DotnetcorePlainIcon,
  DrupalOriginalIcon: DrupalOriginalIcon,
  DrupalOriginalWordmarkIcon: DrupalOriginalWordmarkIcon,
  DrupalPlainIcon: DrupalPlainIcon,
  DrupalPlainWordmarkIcon: DrupalPlainWordmarkIcon,
  DigitaloceanOriginalIcon: DigitaloceanOriginalIcon,
  DigitaloceanOriginalWordmarkIcon: DigitaloceanOriginalWordmarkIcon,
  DigitaloceanPlainIcon: DigitaloceanPlainIcon,
  DigitaloceanPlainWordmarkIcon: DigitaloceanPlainWordmarkIcon,
  ElectronOriginalIcon: ElectronOriginalIcon,
  ElectronOriginalWordmarkIcon: ElectronOriginalWordmarkIcon,
  EleventyOriginalIcon: EleventyOriginalIcon,
  EleventyPlainIcon: EleventyPlainIcon,
  ElixirOriginalIcon: ElixirOriginalIcon,
  ElixirOriginalWordmarkIcon: ElixirOriginalWordmarkIcon,
  ElixirPlainIcon: ElixirPlainIcon,
  ElixirPlainWordmarkIcon: ElixirPlainWordmarkIcon,
  ElmOriginalIcon: ElmOriginalIcon,
  ElmOriginalWordmarkIcon: ElmOriginalWordmarkIcon,
  ElmPlainIcon: ElmPlainIcon,
  ElmPlainWordmarkIcon: ElmPlainWordmarkIcon,
  EmberOriginalWordmarkIcon: EmberOriginalWordmarkIcon,
  EmbeddedcOriginalIcon: EmbeddedcOriginalIcon,
  EmbeddedcOriginalWordmarkIcon: EmbeddedcOriginalWordmarkIcon,
  EmbeddedcPlainIcon: EmbeddedcPlainIcon,
  EmbeddedcPlainWordmarkIcon: EmbeddedcPlainWordmarkIcon,
  ErlangOriginalIcon: ErlangOriginalIcon,
  ErlangOriginalWordmarkIcon: ErlangOriginalWordmarkIcon,
  ErlangPlainIcon: ErlangPlainIcon,
  ErlangPlainWordmarkIcon: ErlangPlainWordmarkIcon,
  ExpressOriginalIcon: ExpressOriginalIcon,
  ExpressOriginalWordmarkIcon: ExpressOriginalWordmarkIcon,
  FacebookOriginalIcon: FacebookOriginalIcon,
  FacebookPlainIcon: FacebookPlainIcon,
  FeathersjsOriginalIcon: FeathersjsOriginalIcon,
  FigmaOriginalIcon: FigmaOriginalIcon,
  FigmaPlainIcon: FigmaPlainIcon,
  FilezillaPlainIcon: FilezillaPlainIcon,
  FilezillaPlainWordmarkIcon: FilezillaPlainWordmarkIcon,
  FirebasePlainIcon: FirebasePlainIcon,
  FirebasePlainWordmarkIcon: FirebasePlainWordmarkIcon,
  FirefoxPlainIcon: FirefoxPlainIcon,
  FirefoxPlainWordmarkIcon: FirefoxPlainWordmarkIcon,
  FlaskOriginalIcon: FlaskOriginalIcon,
  FlaskOriginalWordmarkIcon: FlaskOriginalWordmarkIcon,
  FlutterOriginalIcon: FlutterOriginalIcon,
  FlutterPlainIcon: FlutterPlainIcon,
  FoundationPlainIcon: FoundationPlainIcon,
  FoundationPlainWordmarkIcon: FoundationPlainWordmarkIcon,
  FsharpOriginalIcon: FsharpOriginalIcon,
  FsharpPlainIcon: FsharpPlainIcon,
  GatlingPlainIcon: GatlingPlainIcon,
  GatlingPlainWordmarkIcon: GatlingPlainWordmarkIcon,
  GatsbyPlainIcon: GatsbyPlainIcon,
  GatsbyOriginalIcon: GatsbyOriginalIcon,
  GatsbyOriginalWordmarkIcon: GatsbyOriginalWordmarkIcon,
  GatsbyPlainWordmarkIcon: GatsbyPlainWordmarkIcon,
  GccOriginalIcon: GccOriginalIcon,
  GccPlainIcon: GccPlainIcon,
  GimpOriginalIcon: GimpOriginalIcon,
  GimpOriginalWordmarkIcon: GimpOriginalWordmarkIcon,
  GimpPlainIcon: GimpPlainIcon,
  GimpPlainWordmarkIcon: GimpPlainWordmarkIcon,
  GitOriginalIcon: GitOriginalIcon,
  GitOriginalWordmarkIcon: GitOriginalWordmarkIcon,
  GitPlainIcon: GitPlainIcon,
  GitPlainWordmarkIcon: GitPlainWordmarkIcon,
  GithubOriginalIcon: GithubOriginalIcon,
  GithubOriginalWordmarkIcon: GithubOriginalWordmarkIcon,
  GitlabOriginalIcon: GitlabOriginalIcon,
  GitlabOriginalWordmarkIcon: GitlabOriginalWordmarkIcon,
  GitlabPlainIcon: GitlabPlainIcon,
  GitlabPlainWordmarkIcon: GitlabPlainWordmarkIcon,
  GitterPlainIcon: GitterPlainIcon,
  GitterPlainWordmarkIcon: GitterPlainWordmarkIcon,
  GoOriginalIcon: GoOriginalIcon,
  GoOriginalWordmarkIcon: GoOriginalWordmarkIcon,
  GoPlainIcon: GoPlainIcon,
  GoLineIcon: GoLineIcon,
  GoogleOriginalIcon: GoogleOriginalIcon,
  GoogleOriginalWordmarkIcon: GoogleOriginalWordmarkIcon,
  GooglePlainIcon: GooglePlainIcon,
  GooglePlainWordmarkIcon: GooglePlainWordmarkIcon,
  GooglecloudOriginalIcon: GooglecloudOriginalIcon,
  GooglecloudOriginalWordmarkIcon: GooglecloudOriginalWordmarkIcon,
  GooglecloudPlainIcon: GooglecloudPlainIcon,
  GooglecloudPlainWordmarkIcon: GooglecloudPlainWordmarkIcon,
  GradlePlainIcon: GradlePlainIcon,
  GradlePlainWordmarkIcon: GradlePlainWordmarkIcon,
  GrailsOriginalIcon: GrailsOriginalIcon,
  GrailsPlainIcon: GrailsPlainIcon,
  GraphqlPlainIcon: GraphqlPlainIcon,
  GraphqlPlainWordmarkIcon: GraphqlPlainWordmarkIcon,
  GroovyPlainIcon: GroovyPlainIcon,
  GruntPlainIcon: GruntPlainIcon,
  GruntPlainWordmarkIcon: GruntPlainWordmarkIcon,
  GruntLineIcon: GruntLineIcon,
  GruntLineWordmarkIcon: GruntLineWordmarkIcon,
  GulpPlainIcon: GulpPlainIcon,
  GodotOriginalIcon: GodotOriginalIcon,
  GodotOriginalWordmarkIcon: GodotOriginalWordmarkIcon,
  GodotPlainIcon: GodotPlainIcon,
  GodotPlainWordmarkIcon: GodotPlainWordmarkIcon,
  HaskellOriginalIcon: HaskellOriginalIcon,
  HaskellOriginalWordmarkIcon: HaskellOriginalWordmarkIcon,
  HaskellPlainIcon: HaskellPlainIcon,
  HaskellPlainWordmarkIcon: HaskellPlainWordmarkIcon,
  HandlebarsOriginalIcon: HandlebarsOriginalIcon,
  HandlebarsOriginalWordmarkIcon: HandlebarsOriginalWordmarkIcon,
  HaxeOriginalIcon: HaxeOriginalIcon,
  HaxePlainIcon: HaxePlainIcon,
  HerokuOriginalIcon: HerokuOriginalIcon,
  HerokuOriginalWordmarkIcon: HerokuOriginalWordmarkIcon,
  HerokuPlainIcon: HerokuPlainIcon,
  HerokuPlainWordmarkIcon: HerokuPlainWordmarkIcon,
  Html5OriginalIcon: Html5OriginalIcon,
  Html5OriginalWordmarkIcon: Html5OriginalWordmarkIcon,
  Html5PlainIcon: Html5PlainIcon,
  Html5PlainWordmarkIcon: Html5PlainWordmarkIcon,
  Ie10OriginalIcon: Ie10OriginalIcon,
  IllustratorPlainIcon: IllustratorPlainIcon,
  IllustratorLineIcon: IllustratorLineIcon,
  InkscapeOriginalIcon: InkscapeOriginalIcon,
  InkscapePlainIcon: InkscapePlainIcon,
  InkscapePlainWordmarkIcon: InkscapePlainWordmarkIcon,
  IntellijOriginalIcon: IntellijOriginalIcon,
  IntellijOriginalWordmarkIcon: IntellijOriginalWordmarkIcon,
  IntellijPlainIcon: IntellijPlainIcon,
  IntellijPlainWordmarkIcon: IntellijPlainWordmarkIcon,
  IonicOriginalIcon: IonicOriginalIcon,
  IonicOriginalWordmarkIcon: IonicOriginalWordmarkIcon,
  JamstackOriginalIcon: JamstackOriginalIcon,
  JamstackOriginalWordmarkIcon: JamstackOriginalWordmarkIcon,
  JamstackPlainWordmarkIcon: JamstackPlainWordmarkIcon,
  JasminePlainIcon: JasminePlainIcon,
  JasminePlainWordmarkIcon: JasminePlainWordmarkIcon,
  JavaOriginalIcon: JavaOriginalIcon,
  JavaOriginalWordmarkIcon: JavaOriginalWordmarkIcon,
  JavaPlainIcon: JavaPlainIcon,
  JavaPlainWordmarkIcon: JavaPlainWordmarkIcon,
  JavascriptOriginalIcon: JavascriptOriginalIcon,
  JavascriptPlainIcon: JavascriptPlainIcon,
  JeetOriginalIcon: JeetOriginalIcon,
  JeetOriginalWordmarkIcon: JeetOriginalWordmarkIcon,
  JeetPlainIcon: JeetPlainIcon,
  JeetPlainWordmarkIcon: JeetPlainWordmarkIcon,
  JestPlainIcon: JestPlainIcon,
  JenkinsLineIcon: JenkinsLineIcon,
  JenkinsPlainIcon: JenkinsPlainIcon,
  JetbrainsOriginalIcon: JetbrainsOriginalIcon,
  JetbrainsPlainIcon: JetbrainsPlainIcon,
  JiraOriginalIcon: JiraOriginalIcon,
  JiraOriginalWordmarkIcon: JiraOriginalWordmarkIcon,
  JiraPlainIcon: JiraPlainIcon,
  JiraPlainWordmarkIcon: JiraPlainWordmarkIcon,
  JqueryOriginalIcon: JqueryOriginalIcon,
  JqueryOriginalWordmarkIcon: JqueryOriginalWordmarkIcon,
  JqueryPlainIcon: JqueryPlainIcon,
  JqueryPlainWordmarkIcon: JqueryPlainWordmarkIcon,
  JuliaOriginalIcon: JuliaOriginalIcon,
  JuliaOriginalWordmarkIcon: JuliaOriginalWordmarkIcon,
  JuliaPlainIcon: JuliaPlainIcon,
  JuliaPlainWordmarkIcon: JuliaPlainWordmarkIcon,
  JupyterOriginalIcon: JupyterOriginalIcon,
  JupyterOriginalWordmarkIcon: JupyterOriginalWordmarkIcon,
  JupyterPlainIcon: JupyterPlainIcon,
  JupyterPlainWordmarkIcon: JupyterPlainWordmarkIcon,
  KarmaOriginalIcon: KarmaOriginalIcon,
  KarmaPlainIcon: KarmaPlainIcon,
  KotlinOriginalIcon: KotlinOriginalIcon,
  KotlinOriginalWordmarkIcon: KotlinOriginalWordmarkIcon,
  KotlinPlainIcon: KotlinPlainIcon,
  KotlinPlainWordmarkIcon: KotlinPlainWordmarkIcon,
  KnockoutPlainWordmarkIcon: KnockoutPlainWordmarkIcon,
  KrakenjsOriginalIcon: KrakenjsOriginalIcon,
  KrakenjsOriginalWordmarkIcon: KrakenjsOriginalWordmarkIcon,
  KrakenjsPlainIcon: KrakenjsPlainIcon,
  KrakenjsPlainWordmarkIcon: KrakenjsPlainWordmarkIcon,
  KubernetesPlainIcon: KubernetesPlainIcon,
  KubernetesPlainWordmarkIcon: KubernetesPlainWordmarkIcon,
  LabviewOriginalIcon: LabviewOriginalIcon,
  LabviewOriginalWordmarkIcon: LabviewOriginalWordmarkIcon,
  LabviewPlainIcon: LabviewPlainIcon,
  LabviewPlainWordmarkIcon: LabviewPlainWordmarkIcon,
  LaravelPlainIcon: LaravelPlainIcon,
  LaravelPlainWordmarkIcon: LaravelPlainWordmarkIcon,
  LessPlainWordmarkIcon: LessPlainWordmarkIcon,
  LinkedinOriginalIcon: LinkedinOriginalIcon,
  LinkedinOriginalWordmarkIcon: LinkedinOriginalWordmarkIcon,
  LinkedinPlainIcon: LinkedinPlainIcon,
  LinkedinPlainWordmarkIcon: LinkedinPlainWordmarkIcon,
  LuaOriginalIcon: LuaOriginalIcon,
  LuaOriginalWordmarkIcon: LuaOriginalWordmarkIcon,
  LuaPlainIcon: LuaPlainIcon,
  LuaPlainWordmarkIcon: LuaPlainWordmarkIcon,
  LinuxPlainIcon: LinuxPlainIcon,
  MaterialuiOriginalIcon: MaterialuiOriginalIcon,
  MaterialuiPlainIcon: MaterialuiPlainIcon,
  MatlabOriginalIcon: MatlabOriginalIcon,
  MatlabPlainIcon: MatlabPlainIcon,
  MatlabLineIcon: MatlabLineIcon,
  MagentoOriginalIcon: MagentoOriginalIcon,
  MagentoOriginalWordmarkIcon: MagentoOriginalWordmarkIcon,
  MagentoLineIcon: MagentoLineIcon,
  MarkdownOriginalIcon: MarkdownOriginalIcon,
  MeteorOriginalIcon: MeteorOriginalIcon,
  MeteorOriginalWordmarkIcon: MeteorOriginalWordmarkIcon,
  MeteorPlainIcon: MeteorPlainIcon,
  MeteorPlainWordmarkIcon: MeteorPlainWordmarkIcon,
  MinitabOriginalIcon: MinitabOriginalIcon,
  MinitabPlainIcon: MinitabPlainIcon,
  MochaPlainIcon: MochaPlainIcon,
  ModxOriginalIcon: ModxOriginalIcon,
  ModxOriginalWordmarkIcon: ModxOriginalWordmarkIcon,
  ModxPlainIcon: ModxPlainIcon,
  ModxPlainWordmarkIcon: ModxPlainWordmarkIcon,
  MongodbOriginalIcon: MongodbOriginalIcon,
  MongodbOriginalWordmarkIcon: MongodbOriginalWordmarkIcon,
  MongodbPlainIcon: MongodbPlainIcon,
  MongodbPlainWordmarkIcon: MongodbPlainWordmarkIcon,
  MoodleOriginalIcon: MoodleOriginalIcon,
  MoodleOriginalWordmarkIcon: MoodleOriginalWordmarkIcon,
  MoodlePlainIcon: MoodlePlainIcon,
  MoodlePlainWordmarkIcon: MoodlePlainWordmarkIcon,
  MsdosOriginalIcon: MsdosOriginalIcon,
  MsdosPlainIcon: MsdosPlainIcon,
  MsdosLineIcon: MsdosLineIcon,
  MysqlOriginalIcon: MysqlOriginalIcon,
  MysqlOriginalWordmarkIcon: MysqlOriginalWordmarkIcon,
  MysqlPlainIcon: MysqlPlainIcon,
  MysqlPlainWordmarkIcon: MysqlPlainWordmarkIcon,
  Neo4jOriginalIcon: Neo4jOriginalIcon,
  Neo4jOriginalWordmarkIcon: Neo4jOriginalWordmarkIcon,
  Neo4jPlainIcon: Neo4jPlainIcon,
  Neo4jPlainWordmarkIcon: Neo4jPlainWordmarkIcon,
  NestjsPlainIcon: NestjsPlainIcon,
  NestjsPlainWordmarkIcon: NestjsPlainWordmarkIcon,
  NextjsOriginalIcon: NextjsOriginalIcon,
  NextjsLineIcon: NextjsLineIcon,
  NextjsOriginalWordmarkIcon: NextjsOriginalWordmarkIcon,
  NginxOriginalIcon: NginxOriginalIcon,
  NixosOriginalIcon: NixosOriginalIcon,
  NixosOriginalWordmarkIcon: NixosOriginalWordmarkIcon,
  NixosPlainIcon: NixosPlainIcon,
  NixosPlainWordmarkIcon: NixosPlainWordmarkIcon,
  NodejsOriginalIcon: NodejsOriginalIcon,
  NodejsOriginalWordmarkIcon: NodejsOriginalWordmarkIcon,
  NodejsPlainIcon: NodejsPlainIcon,
  NodejsPlainWordmarkIcon: NodejsPlainWordmarkIcon,
  NodewebkitOriginalIcon: NodewebkitOriginalIcon,
  NodewebkitOriginalWordmarkIcon: NodewebkitOriginalWordmarkIcon,
  NodewebkitPlainIcon: NodewebkitPlainIcon,
  NodewebkitPlainWordmarkIcon: NodewebkitPlainWordmarkIcon,
  NodewebkitLineIcon: NodewebkitLineIcon,
  NodewebkitLineWordmarkIcon: NodewebkitLineWordmarkIcon,
  NpmOriginalWordmarkIcon: NpmOriginalWordmarkIcon,
  NumpyOriginalIcon: NumpyOriginalIcon,
  NumpyOriginalWordmarkIcon: NumpyOriginalWordmarkIcon,
  NuxtjsOriginalIcon: NuxtjsOriginalIcon,
  NuxtjsOriginalWordmarkIcon: NuxtjsOriginalWordmarkIcon,
  NuxtjsPlainIcon: NuxtjsPlainIcon,
  NuxtjsPlainWordmarkIcon: NuxtjsPlainWordmarkIcon,
  ObjectivecPlainIcon: ObjectivecPlainIcon,
  OperaOriginalIcon: OperaOriginalIcon,
  OperaOriginalWordmarkIcon: OperaOriginalWordmarkIcon,
  OperaPlainIcon: OperaPlainIcon,
  OperaPlainWordmarkIcon: OperaPlainWordmarkIcon,
  OcamlOriginalIcon: OcamlOriginalIcon,
  OcamlOriginalWordmarkIcon: OcamlOriginalWordmarkIcon,
  OcamlPlainIcon: OcamlPlainIcon,
  OcamlPlainWordmarkIcon: OcamlPlainWordmarkIcon,
  OpenglOriginalIcon: OpenglOriginalIcon,
  OpenglPlainIcon: OpenglPlainIcon,
  OracleOriginalIcon: OracleOriginalIcon,
  PandasOriginalIcon: PandasOriginalIcon,
  PandasOriginalWordmarkIcon: PandasOriginalWordmarkIcon,
  PerlOriginalIcon: PerlOriginalIcon,
  PerlPlainIcon: PerlPlainIcon,
  PhalconOriginalIcon: PhalconOriginalIcon,
  PhalconPlainIcon: PhalconPlainIcon,
  PhotoshopPlainIcon: PhotoshopPlainIcon,
  PhotoshopLineIcon: PhotoshopLineIcon,
  PhpPlainIcon: PhpPlainIcon,
  PhpstormOriginalIcon: PhpstormOriginalIcon,
  PhpstormOriginalWordmarkIcon: PhpstormOriginalWordmarkIcon,
  PhpstormPlainIcon: PhpstormPlainIcon,
  PhpstormPlainWordmarkIcon: PhpstormPlainWordmarkIcon,
  PostgresqlOriginalIcon: PostgresqlOriginalIcon,
  PostgresqlOriginalWordmarkIcon: PostgresqlOriginalWordmarkIcon,
  PostgresqlPlainIcon: PostgresqlPlainIcon,
  PostgresqlPlainWordmarkIcon: PostgresqlPlainWordmarkIcon,
  PremiereproPlainIcon: PremiereproPlainIcon,
  PremiereproOriginalIcon: PremiereproOriginalIcon,
  ProcessingOriginalIcon: ProcessingOriginalIcon,
  ProcessingOriginalWordmarkIcon: ProcessingOriginalWordmarkIcon,
  ProcessingPlainIcon: ProcessingPlainIcon,
  ProcessingPlainWordmarkIcon: ProcessingPlainWordmarkIcon,
  ProtractorPlainIcon: ProtractorPlainIcon,
  ProtractorPlainWordmarkIcon: ProtractorPlainWordmarkIcon,
  PuttyOriginalIcon: PuttyOriginalIcon,
  PuttyPlainIcon: PuttyPlainIcon,
  PycharmOriginalIcon: PycharmOriginalIcon,
  PycharmOriginalWordmarkIcon: PycharmOriginalWordmarkIcon,
  PycharmPlainIcon: PycharmPlainIcon,
  PycharmPlainWordmarkIcon: PycharmPlainWordmarkIcon,
  PythonOriginalIcon: PythonOriginalIcon,
  PythonOriginalWordmarkIcon: PythonOriginalWordmarkIcon,
  PythonPlainIcon: PythonPlainIcon,
  PythonPlainWordmarkIcon: PythonPlainWordmarkIcon,
  RaspberrypiOriginalIcon: RaspberrypiOriginalIcon,
  RaspberrypiOriginalWordmarkIcon: RaspberrypiOriginalWordmarkIcon,
  RaspberrypiLineIcon: RaspberrypiLineIcon,
  RaspberrypiLineWordmarkIcon: RaspberrypiLineWordmarkIcon,
  PhoenixOriginalIcon: PhoenixOriginalIcon,
  PhoenixOriginalWordmarkIcon: PhoenixOriginalWordmarkIcon,
  PhoenixPlainIcon: PhoenixPlainIcon,
  PhoenixPlainWordmarkIcon: PhoenixPlainWordmarkIcon,
  QtOriginalIcon: QtOriginalIcon,
  ROriginalIcon: ROriginalIcon,
  RPlainIcon: RPlainIcon,
  RailsOriginalWordmarkIcon: RailsOriginalWordmarkIcon,
  RailsPlainIcon: RailsPlainIcon,
  RailsPlainWordmarkIcon: RailsPlainWordmarkIcon,
  ReactOriginalIcon: ReactOriginalIcon,
  ReactOriginalWordmarkIcon: ReactOriginalWordmarkIcon,
  RedhatOriginalIcon: RedhatOriginalIcon,
  RedhatOriginalWordmarkIcon: RedhatOriginalWordmarkIcon,
  RedhatPlainIcon: RedhatPlainIcon,
  RedhatPlainWordmarkIcon: RedhatPlainWordmarkIcon,
  RedisOriginalIcon: RedisOriginalIcon,
  RedisOriginalWordmarkIcon: RedisOriginalWordmarkIcon,
  RedisPlainIcon: RedisPlainIcon,
  RedisPlainWordmarkIcon: RedisPlainWordmarkIcon,
  ReduxOriginalIcon: ReduxOriginalIcon,
  RocksdbPlainIcon: RocksdbPlainIcon,
  RubyOriginalIcon: RubyOriginalIcon,
  RubyOriginalWordmarkIcon: RubyOriginalWordmarkIcon,
  RubyPlainIcon: RubyPlainIcon,
  RubyPlainWordmarkIcon: RubyPlainWordmarkIcon,
  RubymineOriginalIcon: RubymineOriginalIcon,
  RubymineOriginalWordmarkIcon: RubymineOriginalWordmarkIcon,
  RubyminePlainIcon: RubyminePlainIcon,
  RubyminePlainWordmarkIcon: RubyminePlainWordmarkIcon,
  RustPlainIcon: RustPlainIcon,
  SafariOriginalIcon: SafariOriginalIcon,
  SafariOriginalWordmarkIcon: SafariOriginalWordmarkIcon,
  SafariPlainIcon: SafariPlainIcon,
  SafariPlainWordmarkIcon: SafariPlainWordmarkIcon,
  SafariLineWordmarkIcon: SafariLineWordmarkIcon,
  SafariLineIcon: SafariLineIcon,
  SalesforceOriginalIcon: SalesforceOriginalIcon,
  SalesforcePlainIcon: SalesforcePlainIcon,
  RstudioOriginalIcon: RstudioOriginalIcon,
  RstudioPlainIcon: RstudioPlainIcon,
  SassOriginalIcon: SassOriginalIcon,
  ScalaOriginalIcon: ScalaOriginalIcon,
  ScalaOriginalWordmarkIcon: ScalaOriginalWordmarkIcon,
  ScalaPlainIcon: ScalaPlainIcon,
  ScalaPlainWordmarkIcon: ScalaPlainWordmarkIcon,
  SequelizeOriginalIcon: SequelizeOriginalIcon,
  SequelizeOriginalWordmarkIcon: SequelizeOriginalWordmarkIcon,
  SequelizePlainIcon: SequelizePlainIcon,
  SequelizePlainWordmarkIcon: SequelizePlainWordmarkIcon,
  ShopwareOriginalIcon: ShopwareOriginalIcon,
  ShopwareOriginalWordmarkIcon: ShopwareOriginalWordmarkIcon,
  SketchOriginalIcon: SketchOriginalIcon,
  SketchOriginalWordmarkIcon: SketchOriginalWordmarkIcon,
  SketchLineIcon: SketchLineIcon,
  SketchLineWordmarkIcon: SketchLineWordmarkIcon,
  SlackOriginalIcon: SlackOriginalIcon,
  SlackOriginalWordmarkIcon: SlackOriginalWordmarkIcon,
  SlackPlainIcon: SlackPlainIcon,
  SlackPlainWordmarkIcon: SlackPlainWordmarkIcon,
  SocketioOriginalIcon: SocketioOriginalIcon,
  SocketioOriginalWordmarkIcon: SocketioOriginalWordmarkIcon,
  SourcetreeOriginalIcon: SourcetreeOriginalIcon,
  SourcetreeOriginalWordmarkIcon: SourcetreeOriginalWordmarkIcon,
  SpringOriginalIcon: SpringOriginalIcon,
  SpringOriginalWordmarkIcon: SpringOriginalWordmarkIcon,
  SpringPlainIcon: SpringPlainIcon,
  SpringPlainWordmarkIcon: SpringPlainWordmarkIcon,
  SpssOriginalIcon: SpssOriginalIcon,
  SpssPlainIcon: SpssPlainIcon,
  SqlalchemyOriginalIcon: SqlalchemyOriginalIcon,
  SqlalchemyOriginalWordmarkIcon: SqlalchemyOriginalWordmarkIcon,
  SqlalchemyPlainIcon: SqlalchemyPlainIcon,
  SubversionOriginalIcon: SubversionOriginalIcon,
  SubversionOriginalWordmarkIcon: SubversionOriginalWordmarkIcon,
  MicrosoftsqlserverPlainIcon: MicrosoftsqlserverPlainIcon,
  MicrosoftsqlserverPlainWordmarkIcon: MicrosoftsqlserverPlainWordmarkIcon,
  SshOriginalIcon: SshOriginalIcon,
  SshOriginalWordmarkIcon: SshOriginalWordmarkIcon,
  StylusOriginalIcon: StylusOriginalIcon,
  SvelteOriginalIcon: SvelteOriginalIcon,
  SvelteOriginalWordmarkIcon: SvelteOriginalWordmarkIcon,
  SveltePlainIcon: SveltePlainIcon,
  SveltePlainWordmarkIcon: SveltePlainWordmarkIcon,
  SwiftOriginalIcon: SwiftOriginalIcon,
  SwiftOriginalWordmarkIcon: SwiftOriginalWordmarkIcon,
  SwiftPlainIcon: SwiftPlainIcon,
  SwiftPlainWordmarkIcon: SwiftPlainWordmarkIcon,
  SymfonyOriginalIcon: SymfonyOriginalIcon,
  SymfonyOriginalWordmarkIcon: SymfonyOriginalWordmarkIcon,
  StorybookOriginalIcon: StorybookOriginalIcon,
  StorybookOriginalWordmarkIcon: StorybookOriginalWordmarkIcon,
  StorybookPlainIcon: StorybookPlainIcon,
  StorybookPlainWordmarkIcon: StorybookPlainWordmarkIcon,
  TailwindcssOriginalWordmarkIcon: TailwindcssOriginalWordmarkIcon,
  TailwindcssPlainIcon: TailwindcssPlainIcon,
  TensorflowOriginalIcon: TensorflowOriginalIcon,
  TensorflowLineIcon: TensorflowLineIcon,
  ThreejsOriginalIcon: ThreejsOriginalIcon,
  ThreejsOriginalWordmarkIcon: ThreejsOriginalWordmarkIcon,
  TomcatOriginalIcon: TomcatOriginalIcon,
  TomcatOriginalWordmarkIcon: TomcatOriginalWordmarkIcon,
  TomcatLineIcon: TomcatLineIcon,
  TomcatLineWordmarkIcon: TomcatLineWordmarkIcon,
  TortoisegitPlainIcon: TortoisegitPlainIcon,
  TortoisegitLineIcon: TortoisegitLineIcon,
  TowergitOriginalIcon: TowergitOriginalIcon,
  TowergitOriginalWordmarkIcon: TowergitOriginalWordmarkIcon,
  TowergitPlainIcon: TowergitPlainIcon,
  TowergitPlainWordmarkIcon: TowergitPlainWordmarkIcon,
  TravisPlainIcon: TravisPlainIcon,
  TravisPlainWordmarkIcon: TravisPlainWordmarkIcon,
  ThealgorithmsOriginalIcon: ThealgorithmsOriginalIcon,
  ThealgorithmsOriginalWordmarkIcon: ThealgorithmsOriginalWordmarkIcon,
  ThealgorithmsPlainIcon: ThealgorithmsPlainIcon,
  ThealgorithmsPlainWordmarkIcon: ThealgorithmsPlainWordmarkIcon,
  TrelloPlainIcon: TrelloPlainIcon,
  TrelloPlainWordmarkIcon: TrelloPlainWordmarkIcon,
  TwitterOriginalIcon: TwitterOriginalIcon,
  TypescriptOriginalIcon: TypescriptOriginalIcon,
  TypescriptPlainIcon: TypescriptPlainIcon,
  Typo3OriginalIcon: Typo3OriginalIcon,
  Typo3OriginalWordmarkIcon: Typo3OriginalWordmarkIcon,
  Typo3PlainIcon: Typo3PlainIcon,
  Typo3PlainWordmarkIcon: Typo3PlainWordmarkIcon,
  UbuntuPlainIcon: UbuntuPlainIcon,
  UbuntuPlainWordmarkIcon: UbuntuPlainWordmarkIcon,
  UnityOriginalIcon: UnityOriginalIcon,
  UnityOriginalWordmarkIcon: UnityOriginalWordmarkIcon,
  UnixOriginalIcon: UnixOriginalIcon,
  UwsgiOriginalIcon: UwsgiOriginalIcon,
  UwsgiPlainIcon: UwsgiPlainIcon,
  VagrantOriginalIcon: VagrantOriginalIcon,
  VagrantOriginalWordmarkIcon: VagrantOriginalWordmarkIcon,
  VagrantPlainIcon: VagrantPlainIcon,
  VagrantPlainWordmarkIcon: VagrantPlainWordmarkIcon,
  VimOriginalIcon: VimOriginalIcon,
  VimPlainIcon: VimPlainIcon,
  VisualstudioPlainIcon: VisualstudioPlainIcon,
  VisualstudioPlainWordmarkIcon: VisualstudioPlainWordmarkIcon,
  VuejsOriginalIcon: VuejsOriginalIcon,
  VuejsOriginalWordmarkIcon: VuejsOriginalWordmarkIcon,
  VuejsPlainIcon: VuejsPlainIcon,
  VuejsPlainWordmarkIcon: VuejsPlainWordmarkIcon,
  VuejsLineIcon: VuejsLineIcon,
  VuejsLineWordmarkIcon: VuejsLineWordmarkIcon,
  VuestorefrontOriginalIcon: VuestorefrontOriginalIcon,
  VuestorefrontPlainIcon: VuestorefrontPlainIcon,
  VscodeOriginalIcon: VscodeOriginalIcon,
  VscodePlainIcon: VscodePlainIcon,
  WeblateOriginalIcon: WeblateOriginalIcon,
  WeblatePlainIcon: WeblatePlainIcon,
  WeblateOriginalWordmarkIcon: WeblateOriginalWordmarkIcon,
  WeblatePlainWordmarkIcon: WeblatePlainWordmarkIcon,
  WebpackOriginalIcon: WebpackOriginalIcon,
  WebpackOriginalWordmarkIcon: WebpackOriginalWordmarkIcon,
  WebpackPlainIcon: WebpackPlainIcon,
  WebpackPlainWordmarkIcon: WebpackPlainWordmarkIcon,
  WebstormOriginalIcon: WebstormOriginalIcon,
  WebstormOriginalWordmarkIcon: WebstormOriginalWordmarkIcon,
  WebstormPlainIcon: WebstormPlainIcon,
  WebstormPlainWordmarkIcon: WebstormPlainWordmarkIcon,
  Windows8OriginalIcon: Windows8OriginalIcon,
  Windows8OriginalWordmarkIcon: Windows8OriginalWordmarkIcon,
  WoocommerceOriginalIcon: WoocommerceOriginalIcon,
  WoocommercePlainIcon: WoocommercePlainIcon,
  WoocommerceOriginalWordmarkIcon: WoocommerceOriginalWordmarkIcon,
  WoocommercePlainWordmarkIcon: WoocommercePlainWordmarkIcon,
  WordpressOriginalIcon: WordpressOriginalIcon,
  WordpressPlainIcon: WordpressPlainIcon,
  WordpressPlainWordmarkIcon: WordpressPlainWordmarkIcon,
  XdPlainIcon: XdPlainIcon,
  XdLineIcon: XdLineIcon,
  YarnOriginalIcon: YarnOriginalIcon,
  YarnOriginalWordmarkIcon: YarnOriginalWordmarkIcon,
  YiiOriginalIcon: YiiOriginalIcon,
  YiiPlainIcon: YiiPlainIcon,
  YiiPlainWordmarkIcon: YiiPlainWordmarkIcon,
  YunohostOriginalIcon: YunohostOriginalIcon,
  ZendPlainIcon: ZendPlainIcon,
  ZendPlainWordmarkIcon: ZendPlainWordmarkIcon,
  ZigOriginalIcon: ZigOriginalIcon,
  ZigOriginalWordmarkIcon: ZigOriginalWordmarkIcon,
  ZigPlainWordmarkIcon: ZigPlainWordmarkIcon,
  BabelOriginalIcon: BabelOriginalIcon,
  BootstrapOriginalIcon: BootstrapOriginalIcon,
  ComposerLineIcon: ComposerLineIcon,
  ComposerLineWordmarkIcon: ComposerLineWordmarkIcon,
  DeviconLineWordmarkIcon: DeviconLineWordmarkIcon,
  DotNetOriginalWordmarkIcon: DotNetOriginalWordmarkIcon,
  FoundationOriginalIcon: FoundationOriginalIcon,
  FoundationOriginalWordmarkIcon: FoundationOriginalWordmarkIcon,
  GruntOriginalIcon: GruntOriginalIcon,
  GruntOriginalWordmarkIcon: GruntOriginalWordmarkIcon,
  InkscapeOriginalWordmarkIcon: InkscapeOriginalWordmarkIcon,
  JenkinsOriginalIcon: JenkinsOriginalIcon,
  PhpOriginalIcon: PhpOriginalIcon,
  CplusplusOriginalIcon: CplusplusOriginalIcon,
  CouchdbPlainWordmarkIcon: CouchdbPlainWordmarkIcon,
  CouchdbPlainIcon: CouchdbPlainIcon,
  TortoisegitOriginalIcon: TortoisegitOriginalIcon,
  VscodeOriginalWordmarkIcon: VscodeOriginalWordmarkIcon,
  VscodePlainWordmarkIcon: VscodePlainWordmarkIcon,
  YiiOriginalWordmarkIcon: YiiOriginalWordmarkIcon,
  ComposerOriginalIcon: ComposerOriginalIcon,
  FirefoxOriginalIcon: FirefoxOriginalIcon,
  FirefoxOriginalWordmarkIcon: FirefoxOriginalWordmarkIcon,
  GroovyOriginalIcon: GroovyOriginalIcon,
  YunohostPlainIcon: YunohostPlainIcon,
  ApacheOriginalIcon: ApacheOriginalIcon,
  ApacheOriginalWordmarkIcon: ApacheOriginalWordmarkIcon,
  LinuxOriginalIcon: LinuxOriginalIcon,
  TensorflowOriginalWordmarkIcon: TensorflowOriginalWordmarkIcon,
  TensorflowLineWordmarkIcon: TensorflowLineWordmarkIcon
};